export interface IListMedicalSpecialtiesEndpointQuery {
  treatment_category_id?: string;
}

export interface IListMedicalSpecialtiesEndpointResponse {
  list: {
    id: string;
    sku: number;
    title: string;
  }[];
}

export const listMedicalSpecialtiesEndpoint = () => '/medical-specialties';
